import Proxy from './Proxy';

class StoreFloorProxy extends Proxy {

  constructor(parameters = {}) {
    super('api/store/store-floors', parameters);
  }

  /**
   * 층별 매체 위치 정보
   * @param storeFloorSeq
   * @returns {Promise}
   */
  findAllMediaPosition(storeFloorSeq) {
    return this.submit('get', `${this.endpoint}/${storeFloorSeq}/media-positions`);
  }

  /**
   * 층별 매체 위지 저장
   * @param storeFloorSeq
   * @param mediaPositions
   * @returns {Promise}
   */
  createMediaPosition(storeFloorSeq, mediaPositions) {
    return this.submit('put', `${this.endpoint}/${storeFloorSeq}/media-positions`, { storeFloorSeq : storeFloorSeq,  mediaPositions : mediaPositions});
  }

}

export default StoreFloorProxy;
